import _ from 'lodash'
import Vue from 'vue'

export default {

  setTender(state, payload) {
    state.tender = _.cloneDeep(payload)
  },
  ediTender(state, payload) {
    state.tender = Object.assign( state.tender, payload)
  },
  setTenders(state, payload) {
    state.tenders = payload
  },
  setTendersCount(state, payload) {
    if (state.tendersCount != payload) {
      state.tendersCount = payload
    }
  },
  settendersCountsByTypes(state, payload) {
    if (JSON.stringify(state.tendersCountsByTypes || '{}') != JSON.stringify(payload || '{}')) {
      state.tendersCountsByTypes = payload
    }
  },
  setNewTender(state, payload) {
    state.newTender = _.cloneDeep(payload)
  },
  setDefaultTender(state) {
    state.newTender = _.cloneDeep(state.defaultTender)
  },
  setNewTenderInfo(state, payload) {
    state.NewTenderInfo = payload
  },
  editNewTender(state, payload) {
    state.newTender = Object.assign(this.getters.getNewTender, payload)
  },
  setClassifications(state, payload) {
    state.classifications = payload
  },
  setBiddingTypes(state, payload) {
    if (!payload) { return }
    payload.sort((a,b) => a.titleRu?.localeCompare(b.titleRu))
    state.biddingTypes = payload.filter(i => i.allowCreation)
    state.allBiddingTypes = payload
  },
  setProlongationRule(state, payload) {
    state.prolongationRule = payload
  },
  setTenderContactPersons(state, payload) {
    state.tenderContactPersons = (payload || [])
      .sort((a,b) => a.name?.localeCompare(b.name))
  },
  setAdditionalTenderContactPersons(state, payload) {
    state.additionalTenderContactPersons = payload
  },
  addTenders(state, payload) {
    state.tenders = payload
    // let oldTenders = state.tenders
    // payload.forEach(w => {
    //   let tender = oldTenders.find(y => y.tenderId == w.tenderId)
    //   if ( !tender) {
    //     state.tenders.push(w)
    //   } else {
    //     Object.assign(tender , w)
    //   }
    // })
  },
  addTenderInfo(state, payload) {
    let tender = state.tenders.find( el => {
      if (el.tenderId ==  payload.tenderId) {
        Object.assign(el , payload)
        return true
      }
    })
    if (!tender) {
      state.tenders.push(payload)
    }
  },
  setAgreements(state, payload) {
    const seen = new WeakSet()
    const items = JSON.parse(JSON.stringify(payload.items ?? [], (key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) { return undefined }
        seen.add(value)
      }
      return value
    }))
    if (payload.push) {
      state.agreements = (state.agreements || []).concat(items)
    } else {
      state.agreements = items
    }
  },
  addInfoToTenders(state, payload) {
    let size = payload.size,
      all_tenders = state.tenders,
      tenders = _.takeRight( all_tenders , size )

    tenders.forEach( (el, n) => {
      let agreement = payload.items.find( it => el.tenderId == it.tenderId ),
        ind = all_tenders.length - tenders.length + n
      if (agreement) {
        state.tenders[ind].agreement = agreement.agreements
      } else {
        state.tenders[ind].agreement = state.tenders[ind].agreement || []
      }
    })
  },
  addNewTender(state, payload) {
    state.tenders.unshift(payload)
  },
  setTreeView(state, payload) {
    state.treeView = payload
  },
  setMesurementUnit(state, payload) {
    state.mesurementUnit = payload
  },
  setTopMesurementUnit(state, payload) {
    state.topMesurementUnit = payload
  },
  /**
   * Пропозиції для сторінки порівняння, прив'язані до тендеру —
   * щоб на порівнянні іншого тендеру не показались чужі пропозиції
   */
  setCompareItems(state, { tenderId = null, items = [] } = {}) {
    state.compareItems = { tenderId, items }
  },
  setCurrencies(state, payload) {
    state.currencies = payload
  },
  setSubcategories(state, payload) {
    state.subcategories.push(...payload)
  },
  setResourcesItems(state, payload) {
    state.tenderResources[payload.category] = payload.items
  },
  setSubscribedUsers(state, payload) {
    state.subscribers[payload.classificationCode] = payload.items
  },
  setSTProfile(state, payload) {
    state.tenderProfile = payload
  },
  setTenderStatuses(state, payload) {
    state.tenderStatuses = payload ? payload.filter(i => i.isUsed) : []
    state.tenderAllStatuses = payload
  },
  setDepartmentsToState(state, payload) {
    state.departments = payload
  },
  setNbuCurrencyRateToState(state, payload) {
    if (!payload) {
      return
    }
    if (!state.nbuCurrencyRate) {
      state.nbuCurrencyRate = {}
    }
    Vue.prototype.$set(state.nbuCurrencyRate, payload.nbuId, payload)
  },
  setTendersSettings(state, payload) {
    state.tenderSettings = payload
  },
  setSupplierAddress(state, payload) {
    state.supplierAddress = payload
  },
  setHolidays(state, payload) {
    state.holidays.push(...payload)
    state.holidays = _.uniqBy( state.holidays , 'date')
  },
  setMinPproposalsDate(state, payload) {
    state.min_proposals_date = payload
  },
  setCriterionCards(state, payload) {
    state.criterion_cards.push(payload)
  },
  setCriterionCardId(state, payload) {
    if ( !payload?.id ) { return }
    state.criterion_cards_by_id[payload?.id] = payload
  },
  setAvailableCards(state, payload) {
    state.availableCards.push(payload)
  },
  setCriteriaCardTemplates(state, payload) {
    state.criteria_card_templates = payload
  },
  setFiltersTemplatesByType(state, payload) {
    state.filters_templates[payload.name] = payload.items
  },
  editFiltersTemplate(state, payload) {
    let index = state.filters_templates[payload.filterType].findIndex(el => el.id == payload.id)
    if ( index != -1 ) {
      state.filters_templates[payload.filterType][index].isDefault = payload.isDefault
      state.filters_templates[payload.filterType][index].isPinned = payload.isPinned
      state.filters_templates[payload.filterType][index].filterName = payload.filterName
    }
  },
  addFilterTemplate(state, payload) {
    let filters_templates = state.filters_templates[payload.filterType]
    filters_templates ||= []
    filters_templates.push(payload)
  },
  deleteFilterTemplate(state, payload) {
    state.filters_templates[payload.type] = state.filters_templates[payload.type].filter(el => el.id != payload.id)
  },
  setFilters(state, payload) {
    if ( payload.name && state.filters[payload.name] ) {
      state.filters[payload.name].filters = payload.filters || state.filters[payload.name].filters
      state.filters[payload.name].filters_mode = payload.filters_mode ?? state.filters[payload.name].filters_mode
      state.filters[payload.name].search = payload.search || state.filters[payload.name].search
      state.filters[payload.name].type = payload.type || state.filters[payload.name].type
      state.filters[payload.name].checkActualFilters = payload.checkActualFilters || state.filters[payload.name].checkActualFilters
    }

  },
  setPersonalManagers(state, payload) {
    state.personalManagers = payload
  },
}
